import React from "react";
import { Col, Container, Row, Image, Button } from "react-bootstrap";

export const AboutMeSection = () => {
  return (
    <Container fluid className="about-me-section">
      <Container>
        <Row>
          <Col sm="12" md="12" lg="3">
            <h2>About Me</h2>
          </Col>
          <Col sm="12" md="12" lg="9">
            <p className="blurb">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sit
              amet justo ex. Proin efficitur egestas erat eu porttitor. Maecenas
              mollis sapien et mauris posuere, at pretium lacus mollis. Integer
              at auctor nibh.
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm="12" md="12" lg="6">
            <Image
              fluid
              data-aos="fade-up"
              src="https://via.placeholder.com/500"
              alt="Placeholder image"
            />
          </Col>
          <Col sm="12" md="12" lg="6" data-aos="fade-left">
            <p className="further-context-text">
              Ut vel officiis mollitia. Incidunt repudiandae quaerat aperiam
              temporibus nihil quia. Quo nostrum aut minus sint est. Distinctio
              ut deserunt iste. Nemo delectus sed consectetur neque modi. Ullam
              dicta dolorem quas. Soluta consequatur sed non reiciendis. Quia
              libero voluptatem eveniet. Illum praesentium iure fuga
              voluptatibus occaecati saepe laboriosam nulla. Qui voluptatem qui
              expedita neque. Est excepturi rerum placeat velit. Ad maxime non
              vel id. Praesentium nihil tenetur incidunt et neque. Consequatur
              tenetur facere deserunt maiores qui minima similique. Iste fugiat
              praesentium dolorem ut. Rerum est error accusamus aut. Et quia aut
              praesentium eum eum. Ducimus repudiandae qui sunt vero quod quod.
            </p>
            <a href="/about">
              <Button variant="site-alt">Find Out More</Button>
            </a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
